import { useRef } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { CareCreditChip } from '@frontend/payments-care-credit';
import { Text } from '@frontend/design-system';
import { useCollectPaymentMultiContext } from '../../../collect-payment-multi.context';
import { PAYMENT_MULTI_STEP_LABELS, PAYMENT_MULTI_STEPS } from '../../../utils/steps';
import { StyledStep } from '../../atoms/styled-step';
import type { CareCreditPreapprovedDisclosureBodyProps } from './care-credit-preapproved-disclosure.types';

const styles = {
  content: css`
    display: flex;
    flex-direction: column;
    gap: var(--fabric-space-gap-xs);
  `,
};

export const CareCreditPreapprovedDisclosureBody = ({
  onGoBack,
  onCompleteStep,
}: CareCreditPreapprovedDisclosureBodyProps) => {
  const { t } = useTranslation();
  const { careCreditData } = useCollectPaymentMultiContext();
  const applicantStatus = careCreditData?.status;
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <StyledStep
      id={PAYMENT_MULTI_STEPS.careCreditPreapprovedDisclosure}
      label={PAYMENT_MULTI_STEP_LABELS[PAYMENT_MULTI_STEPS.careCreditPreapprovedDisclosure]}
      isValid={true}
      footer={{
        showBackButton: true,
        primary: { label: t('Send Approval Link') },
        onClickBack: onGoBack,
        onClickPrimary: onCompleteStep,
      }}
    >
      <div css={styles.content}>
        <div ref={containerRef}>
          <CareCreditChip status={applicantStatus} containerRef={containerRef} isResponsive />
        </div>
        <div>
          <Text>
            {t(
              'Send this customer a secure CareCredit approval link to see if they’re eligible for financing. Customer can pay balance after they complete approval.'
            )}
          </Text>
        </div>
      </div>
    </StyledStep>
  );
};
